// import permissions from './permission.js'
import moment from 'moment-timezone'

const getDefaultState = () => {
  return {
    companies: [],
    sessionExpiresAt: null,
    userId: null,
    currentCompanyId: '',
    ceoId: '',
    adminId: '',
    advisorId: '',
    clientId: '',
    leadId: '',
    calendarView: 'timeGridWeek',
    supportId: '',
    multipleAccount: '',
    advisorDetails: {},
    noOfClientAccount: '',
    isMultipleVerified: '',
    awsConfig: {},
    currentTypeUser: '',
    role: '',
    TRCMData: '',
    TRCMSecrets: '',
    isLoadingApp: false,
    isGlobalLoading: false,
    termsAndConditions: null,
    termsAndConditionsInfo: null,
    trcmURL: null,
    showModalReadOnly: false,
    dateRangeClientReport: '',
    dateRangeCalendar: '',
    totalContractValue: '',
    upcomingUpdateNeed: false,
    calendarInitData: null, // Store useCalendarInit result globally
    itemsPerPage: {
      options: [
        {
          title: '10',
          command: '10',
        },
        {
          title: '50',
          command: '50',
        },
        {
          title: '100',
          command: '100',
        },
      ],
      values: {
        default: '10',
        schwab: '10',
        annuity: '10',
        memberFiles: '10',
        attachment: '10',
        advisorDashboard: '10',
        listOfHouseholds: '10',
        superAdminDashboard: '10',
        superAdminListAdvisors: '10',
        queues: '50',
        trcm: '10',
      },
    },
    selectFilter: {
      options: [
        {
          title: 'Past year',
          command: 'year',
        },
        {
          title: 'Past month',
          command: 'month',
        },
        {
          title: 'Past quarter',
          command: 'quarter',
        },
      ],
      values: {
        default: 'month',
        opportunitiesBlock: 'month',
        pipeLine: 'month',
        countLeeds: 'month',
        numberLeedsFilledData: 'month',
        numberLeedsConverted: 'month',
        numberLeedsClosed: 'month',
      },
    },
    dialog: {
      showDialog: {
        changeName: false,
        changePassword: false,
        shareFileEmailDialog: false,
        previewModal: false,
        annuityModal: false,
        moreOtherInfo: false,
        moreOwnerInfo: false,
        changePhone: false,
        exportSucces: false,
        modalContact: false,
        newLead: false,
        modalNewTable: false,
        modalSucces: false,
        modalTerms: false,
        modalAddAnnuityIndex: false,
        modalInvestmentPackage: false,
        addChildOpportunity: false,
        modalSummaryInfo: false,
        restoreDraft: false,
        newContract: false,
        modalUploadDocuments: false,
      },
    },
    // keep track of active tab in various components
    activeTabs: {
      tasksQueue: 'taskList', // or 'taskQueue'
      giftReferrals: 'client_gifts', // or 'referral_information'
      FinancialDetails: 'Opportunities',
      communicationDetails: 'activity_details', // or 'client_notes'
    },
    permissions: {
      // permissionGroups: permissions.permissions,
    },
    sortMembers: {
      orderBy: 'created_at',
      sortedBy: 'descending',
    },
    memberId: null,
    memberName: null,
    pdfRegion: '',
    showDialogReloadPage: false,
    needUpdateContent: null,
    docShare: null,
    contact: null,
    previewFile: null,
    previewLoader: false,
    opportunityId: null,
    onlyMyMember: false,
    ownerMember: null,
    onlyMyLead: false,
    ownerLead: null,
    onlyMyPreLead: false,
    ownerPreLead: null,
    houseHolderSearch: '',
    isSecureUploadLogin: false,
    summaryInfoMemberId: null,
    uploadMedicareDocsStatus: null,
    uploadPropertyDocsStatus: null,
    uploadInvestmentDocsStatus: null,
    uploadLifeDocsStatus: null,
    uploadSocialDocsStatus: null,
    collectionUploadMedia: null,
    otpType: null,
    pageClientsHelp: null,
    isMemberComponentRefreshKey: 0,
    isMemberTaskRefreshKey: 0,
    secureMemberData: {},
    calendarTimezone: moment.tz.guess(),
    eventContext: {
      startAt: null,
      endAt: null,
      memberId: null,
    },
    floatingPopup: {
      isVisible: false,
      isMinimized: false,
      type: null, // 'opportunity' | 'task' | 'interaction' | 'onboarding'
      formData: {},
      memberId: null,
      opportunityId: null,
      taskId: null,
      interactionId: null,
      position: {
        bottom: 20,
        right: 20,
      },
    },

    exportDetails: {
      type: 'client',
      name: '',
    },
  }
}

const state = getDefaultState()

const actions = {
  resetState({ commit }) {
    commit('resetState')
  },

  setCalendarInitData({ commit }, data) {
    commit('setCalendarInitData', data)
  },

  setEventContext({ commit }, context) {
    commit('setEventContext', context)
  },
}

const mutations = {
  setCalendarInitData(state, data) {
    state.calendarInitData = data
  },
  setCalendarTimezone(state, tz) {
    state.calendarTimezone = tz
  },
  setIsSecureUploadLogin(state, value) {
    state.isSecureUploadLogin = value
  },
  setSecureMemberData(state, value) {
    state.secureMemberData = value
  },
  setNoAccount(state, value) {
    state.noOfClientAccount = value
  },
  setTRCMSecrets(state, value) {
    state.TRCMSecrets = value
  },
  setupcomingUpdateNeed(state, value) {
    state.upcomingUpdateNeed = value
  },
  setMultipleAccountVerified(state, value) {
    state.isMultipleVerified = value
  },
  setDestinationItemsPerPage(state, data) {
    const { destination, value } = data
    state.itemsPerPage.values[destination] = value
  },

  setDestinationSelectFilter(state, data) {
    const { destination, value } = data
    state.selectFilter.values[destination] = value
  },

  setShowModal(state, data) {
    const { destination, value } = data
    state.dialog.showDialog[destination] = value
  },

  setActiveTabs(state, data) {
    const { destination, value } = data
    state.activeTabs[destination] = value
  },
  //Todo: Revisit later if needed
  setPermissions(state, data) {
    console.log('[setPermissions] State role:', state.role)
    console.log('[setPermissions] Data received:', data)

    // Try to find role by exact match first
    let rolePermissions = data.find((role) => role.name === state.role)

    // If no exact match and data has items, use the first one (user's permissions)
    // This handles custom roles where the role name might not match standard roles
    if (!rolePermissions && data.length > 0) {
      console.warn('[setPermissions] No exact role match found. Using first role data for custom role:', state.role)
      rolePermissions = data[0]
    }

    console.log('[setPermissions] Final permissions:', rolePermissions)
    state.permissions = rolePermissions || {}
  },

  setAdvisorDetails(state, value) {
    state.advisorDetails = value
  },

  setSortMembers(state, data) {
    const { orderBy, sortedBy } = data
    state.sortMembers.orderBy = orderBy
    state.sortMembers.sortedBy = sortedBy
  },

  setShowDialogRealodPage(state, value) {
    state.showDialogReloadPage = value
  },

  setPdfRegion(state, value) {
    state.pdfRegion = value
  },

  setMultipleAccount(state, value) {
    state.multipleAccount = value
  },

  setNoOfClientAccount(state, value) {
    state.noOfClientAccount = value
  },

  setDocShare(state, value) {
    state.docShare = value
  },

  setExportDetails(state, payload) {
    state.exportDetails = {
      ...state.exportDetails,
      ...payload,
    }
  },

  setNeedUpdateContent(state, value) {
    state.needUpdateContent = value
  },

  setMemberId(state, value) {
    state.memberId = value
  },

  setMemberName(state, value) {
    state.memberName = value
  },

  setContact(state, value) {
    state.contact = value
  },

  setCompanies(state, value) {
    state.companies = value
  },

  setCurrentCompanyId(state, value) {
    state.currentCompanyId = value
  },

  setAdminId(state, value) {
    state.adminId = value
  },

  setCeoId(state, value) {
    state.ceoId = value
  },

  setAdvisorId(state, value) {
    state.advisorId = value
  },

  setClientId(state, value) {
    state.clientId = value
  },

  setLeadId(state, value) {
    state.leadId = value
  },

  setSupportId(state, value) {
    state.supportId = value
  },

  setResult(state, value) {
    state.Rersult = value
  },

  setCurrentTypeUser(state, value) {
    state.currentTypeUser = value
  },

  setIsClientPreview(state, value) {
    state.isClientPreview = value
  },

  setRole(state, value) {
    state.role = value
  },

  setTrcmData(state, value) {
    state.TRCMData = value
  },

  setUserId(state, value) {
    state.userId = value
  },

  setIsLoadingApp(state, value) {
    state.isLoadingApp = value
  },
  setIsGlobalLoading(state, value) {
    state.isGlobalLoading = value
  },

  setTermsAndConditions(state, value) {
    state.termsAndConditions = value
  },

  setTermsAndConditionsInfo(state, value) {
    state.termsAndConditionsInfo = value
  },

  setTrcmURL(state, value) {
    state.trcmURL = value
  },

  setDateRangeClientReport(state, value) {
    state.dateRangeClientReport = value
  },
  setDateRangeCalendar(state, value) {
    state.dateRangeCalendar = value
  },
  setPreviewFile(state, value) {
    state.previewFile = value
  },

  setPreviewLoader(state, value) {
    state.previewLoader = value
  },

  setOnlyMyMember(state, value) {
    state.onlyMyMember = value
  },

  setOwnerMember(state, value) {
    state.ownerMember = value
  },

  setOnlyMyLead(state, value) {
    state.onlyMyLead = value
  },

  setOwnerLead(state, value) {
    state.ownerLead = value
  },

  setOnlyMyPreLead(state, value) {
    state.onlyMyPreLead = value
  },

  setOwnerPreLead(state, value) {
    state.ownerPreLead = value
  },

  setHouseHolderSearch(state, value) {
    state.houseHolderSearch = value
  },

  setOpportunityId(state, value) {
    state.opportunityId = value
  },

  setShowModalReadOnly(state, value) {
    state.showModalReadOnly = value
  },

  setSummaryInfoMemberId(state, value) {
    state.summaryInfoMemberId = value
  },

  setUploadMedicareDocsStatus(state, value) {
    state.uploadMedicareDocsStatus = value
  },

  setUploadPropertyDocsStatus(state, value) {
    state.uploadPropertyDocsStatus = value
  },

  setUploadInvestmentDocsStatus(state, value) {
    state.uploadInvestmentDocsStatus = value
  },

  setUploadLifeDocsStatus(state, value) {
    state.uploadLifeDocsStatus = value
  },

  setUploadSocialDocsStatus(state, value) {
    state.uploadSocialDocsStatus = value
  },

  setCollectionUploadMedia(state, value) {
    state.collectionUploadMedia = value
  },

  setPageClientsHelp(state, value) {
    state.pageClientsHelp = value
  },

  setOtpType(state, value) {
    state.otpType = value
  },

  setSessionExpiresAt(state, value) {
    state.sessionExpiresAt = value
  },

  setCalendarView(state, value) {
    state.calendarView = value
  },

  setTotalContractValue(state, value) {
    state.totalContractValue = value
  },

  resetState(state) {
    Object.assign(state, getDefaultState())
  },

  setAwsConfig(state, value) {
    state.awsConfig = value
  },

  setIsMemberComponentRefreshKey(state) {
    state.isMemberComponentRefreshKey++
  },

  setIsMemberTaskRefreshKey(state) {
    state.isMemberTaskRefreshKey++
  },

  setEventContext(state, context) {
    state.eventContext = {
      startAt: context.startAt || null,
      endAt: context.endAt || null,
      memberId: context.memberId || null,
    }
  },
  setFloatingPopup(state, payload) {
    state.floatingPopup = { ...state.floatingPopup, ...payload }
  },

  openFloatingPopup(state, { type, memberId, opportunityId, taskId, interactionId, formData }) {
    state.floatingPopup = {
      isVisible: true,
      isMinimized: false,
      type,
      memberId,
      opportunityId,
      taskId,
      interactionId,
      formData: formData || {},
      position: state.floatingPopup.position,
    }
  },

  closeFloatingPopup(state) {
    state.floatingPopup = {
      isVisible: false,
      isMinimized: false,
      type: null,
      formData: {},
      memberId: null,
      opportunityId: null,
      taskId: null,
      interactionId: null,
      position: state.floatingPopup.position,
    }
  },

  minimizeFloatingPopup(state) {
    state.floatingPopup.isMinimized = true
  },

  maximizeFloatingPopup(state) {
    state.floatingPopup.isMinimized = false
  },

  updateFloatingPopupFormData(state, formData) {
    state.floatingPopup.formData = { ...state.floatingPopup.formData, ...formData }
  },

  updateFloatingPopupPosition(state, position) {
    state.floatingPopup.position = { ...state.floatingPopup.position, ...position }
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
